import { getType } from 'typesafe-actions';
import { DataState } from '../../state';
import { RootAction, NewsUpdateEventAction } from '../../actions';
import { Middleware, Dispatch } from 'redux';
import { NewsActions } from '../../actions/NewsActions';
import { InfoDataActions } from '../../actions/InfoActions';

export const handleNewsFeedUpdates = (dispatch: Dispatch<RootAction>, action: NewsUpdateEventAction) => {
  // Add to the news cache
  dispatch(InfoDataActions.cacheMarketNews({ news: action.payload.news }));
};
export const NewsFeedMiddleware: Middleware<Dispatch<RootAction>, DataState, Dispatch<RootAction>> = middleware => (
  next: Dispatch<RootAction>
) => (action: RootAction) => {
  try {
    const dispatch = middleware.dispatch;
    const result = next(action);
    switch (action.type) {
      case getType(NewsActions.receivedNewsUpdate):
        handleNewsFeedUpdates(dispatch, action);
        break;
    }
    return result;
  } catch (err) {
    console.error('NewsFeedMiddleware :: Caught an exception for action ', action, err);
  }
};
